import type { CatalogCsvEntityKind } from '../../domain/csv/csvEntityKinds';

export const CATEGORY_CSV_HEADERS = [
  'categoria_id',
  'nombre',
  'codigo',
  'aplica_a',
  'margen_default',
  'descripcion',
  'activo',
] as const;

export const BRAND_CSV_HEADERS = ['marca_id', 'nombre', 'codigo', 'sitio_web', 'markup_default', 'activo'] as const;

export const SUPPLIER_CSV_HEADERS = [
  'proveedor_id',
  'nombre',
  'codigo',
  'cuit',
  'contacto_nombre',
  'contacto_email',
  'contacto_telefono',
  'direccion',
  'ciudad',
  'provincia',
  'codigo_postal',
  'plazo_pago',
  'dias_entrega',
  'monto_minimo_pedido',
  'sitio_web',
  'notas',
  'numero_cuenta',
  'activo',
] as const;

export const PRODUCT_CSV_HEADERS = [
  'sku',
  'nombre',
  'precio',
  'codigo_barras',
  'tipo',
  'categoria_id',
  'categoria',
  'marca_id',
  'marca',
  'proveedor_preferido_id',
  'proveedor_preferido',
  'codigo_proveedor',
  'notas',
  'activo',
  // #712: columnas de variante (opcionales — vacías = producto sin variantes).
  // Una fila por variante. El parent se identifica por SKU.
  // Si un producto tiene varias variantes, se repite el SKU del parent en cada fila.
  'variante_sku',
  'variante_codigo_barras',
  'variante_precio',
  'variante_eje_1',
  'variante_valor_1',
  'variante_eje_2',
  'variante_valor_2',
  'variante_eje_3',
  'variante_valor_3',
] as const;

export function catalogCsvHeadersFor(entity: CatalogCsvEntityKind): readonly string[] {
  switch (entity) {
    case 'categories':
      return CATEGORY_CSV_HEADERS;
    case 'brands':
      return BRAND_CSV_HEADERS;
    case 'suppliers':
      return SUPPLIER_CSV_HEADERS;
    case 'products':
      return PRODUCT_CSV_HEADERS;
    default:
      return [];
  }
}

/** Columnas que el archivo tiene que traer. El resto es opcional (export las incluye). */
export function catalogCsvRequiredHeadersFor(entity: CatalogCsvEntityKind): readonly string[] {
  switch (entity) {
    case 'categories':
      return ['nombre'];
    case 'brands':
      return ['nombre'];
    case 'suppliers':
      return ['nombre'];
    case 'products':
      return ['sku'];
    default:
      return [];
  }
}

export function catalogCsvTemplateFilename(entity: CatalogCsvEntityKind): string {
  switch (entity) {
    case 'categories':
      return 'plantilla_categorias.csv';
    case 'brands':
      return 'plantilla_marcas.csv';
    case 'suppliers':
      return 'plantilla_proveedores.csv';
    case 'products':
      return 'plantilla_productos.csv';
    default:
      return 'plantilla.csv';
  }
}

export function catalogCsvExportFilename(entity: CatalogCsvEntityKind): string {
  const stamp = new Date().toISOString().slice(0, 10);
  switch (entity) {
    case 'categories':
      return `categorias_${stamp}.csv`;
    case 'brands':
      return `marcas_${stamp}.csv`;
    case 'suppliers':
      return `proveedores_${stamp}.csv`;
    case 'products':
      return `productos_${stamp}.csv`;
    default:
      return `export_${stamp}.csv`;
  }
}
